module.exports = __webpack_public_path__ + "static/media/khotang2.121bcfb6.ogg";